import { StepValidationState } from "../../../../../interfaces/step";
import { SearchStepper } from "../search-stepper";
import { BusinessReportReviewComponent } from "projects/reg-hub-client/src/app/orders/business-report-review/business-report-review.component";

// Financial institution (OSFI) business reports are always ordered from a business search result and have no
// registration number, so there are no report criteria to enter.
export class FNBusinessReportStepper extends SearchStepper {

    constructor() {
        super()

        this.steps = [
            { title: "Review", content: BusinessReportReviewComponent, validationState: StepValidationState.DefaultState }
        ];
    }
}
